import { gql } from "@/__generated__/gql";

export const LIVE_EVENT_DETAIL_STATS = gql(`
query liveEventStats($eventId: ID!, $filters:StudentListFilterInput) {
    node(id: $eventId) {
      id
      ... on LiveEvent {
        statistics(filters:$filters) {
          studentsWhoMessaged
          totalMessages
          totalChannelOpens
          totalParticipants
        }
      }
    }
  }
`);
